/** Draft only: never consumed by the authentication store or login guards. */
export interface SecurityPolicyDraft {
  mfaRequirement: 'disabled' | 'optional' | 'admins' | 'all';
  riskTriggers: Array<'newDevice' | 'unusualLocation'>;
  riskAction: 'challenge' | 'deny' | 'notify';
  deliveryMethods: Array<'sms' | 'email'>;
  codeMinutes: number;
  resendSeconds: number;
  maxCodeAttempts: number;
}

export const policyNumberLimits = {
  codeMinutes: [1, 10],
  resendSeconds: [30, 300],
  maxCodeAttempts: [1, 10],
} as const;
